import React, { useEffect, useState } from "react";
import { Button, Form, Col, Row } from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../_metronic/_partials/controls";

import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  resetData,
  selectData,
  selectLoading,
  selectPageNo,
  selectPageSize,
  selectTotalRecord,
  fetchData,
  fetchExport,
  fetchExportNoBlob,
} from "./reportSlice";
import { LayoutSplashScreen } from "../../../_metronic/layout";
import {
  CallApiExport,
  createChangeHandler,
  getValueStatus,
  paramsMasterAll,
  setOptionsMaster,
  showDialog,
  showErrorDialog,
} from "../../utility";
import { ReportTable } from "./ReportTable";
import { fetchUser, selectDataUser } from "../user/userSlice";
import { fetchCustomer, selectCustomer } from "../customer/customerSlice";
import Select from "react-select";
import {
  fetchParam,
  fetchParam3,
  selectDataParam,
  selectDataParam3,
} from "../param/paramSlice";
import { InputDateRange } from "../../utility/InputDateRange";
import { fetchBranch, selectBranch } from "../branch/branchSlice";

export const ReportPage = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const data = useSelector(selectData);
  const loading = useSelector(selectLoading);
  const pageNo = useSelector(selectPageNo);
  const pageSize = useSelector(selectPageSize);
  const totalRecord = useSelector(selectTotalRecord);
  const dataUser = useSelector(selectDataUser);
  const dataCustomer = useSelector(selectCustomer);
  const dataParam3 = useSelector(selectDataParam3);
  const dataParam = useSelector(selectDataParam);
  const dataBranch = useSelector(selectBranch);

  // Filter
  const [report, setReport] = useState("");
  const [sales, setSales] = useState("");
  const [customer, setCustomer] = useState("");
  const [product, setProduct] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [payment, setPayment] = useState("");
  const [startPaymentDate, setStartPaymentDate] = useState("");
  const [endPaymentDate, setEndPaymentDate] = useState("");

  const [optionsSales, setOptionsSales] = useState([]);
  const [optionsCustomer, setOptionsCustomer] = useState([]);
  const [optionsPaymentType, setOptionPaymentType] = useState([]);
  const [optionsReport, setOptionReport] = useState([]);

  const [branch, setBranch] = useState("");
  const [optionsBranch, setOptionBranch] = useState([]);
  const handleChangeBranch = createChangeHandler(setBranch);

  useEffect(() => {
    // Reset on first load
    dispatch(resetData());
  }, [dispatch]);

  useEffect(() => {
    async function fetchMyAPI() {
      await dispatch(
        fetchUser({
          ...paramsMasterAll,
          roles_in: "COMPANY_SALES,COMPANY_SUPERVISOR",
          is_active: true,
        })
      );
      await dispatch(
        fetchParam3({
          ...paramsMasterAll,
          param_group_code: "PAYMENT_TYPE",
          is_active: true,
        })
      );
      await dispatch(
        fetchParam({
          ...paramsMasterAll,
          param_group_code: "REPORT_TYPE",
          is_active: true,
        })
      );
      await dispatch(fetchBranch({ ...paramsMasterAll }));
    }
    fetchMyAPI();
  }, [dispatch]);

  useEffect(() => {
    if (dataBranch && dataBranch.length > 0) {
      setOptionsMaster(
        dataBranch,
        setOptionBranch,
        "branch_code",
        "branch_name"
      );
    }
  }, [dataBranch]);

  useEffect(() => {
    if (dataUser.length > 0) {
      setOptionsMaster(
        dataUser,
        setOptionsSales,
        "company_sales_code",
        "name_username"
      );
    }
  }, [dataUser]);
  useEffect(() => {
    if (dataCustomer.length > 0) {
      setOptionsMaster(
        dataUser,
        setOptionsCustomer,
        "customer_code",
        "customer_name"
      );
    }
  }, [dataCustomer]);
  useEffect(() => {
    if (dataParam3.length > 0) {
      setOptionsMaster(
        dataParam3,
        setOptionPaymentType,
        "param_code",
        "param_value"
      );
    }
  }, [dataParam3]);

  useEffect(() => {
    if (dataParam.length > 0) {
      setOptionsMaster(dataParam, setOptionReport, "param_code", "param_value");
    }
  }, [dataParam]);

  const paramsFilter = {
    company_sales_code: sales,
    start_journey_date: startDate,
    end_journey_date: endDate,
    product_code: product,
    customer_code: customer,
    payment_type: payment,
    report_type: report,
    lsColumnHide: "logo,active_token",
    branch_code: branch,
    start_payment_date: startPaymentDate,
    end_payment_date: endPaymentDate,
  };
  const paramsDownload = {
    company_sales_code: sales,
    start_journey_date: startDate,
    end_journey_date: endDate,
    product_code: product,
    customer_code: customer,
    payment_type: payment,
    report_type: report,
    branch_code: branch,
    start_payment_date: startPaymentDate,
    end_payment_date: endPaymentDate,
  };

  const handleSearch = async () => {
    if (report === "") {
      return showDialog("Please select report type");
    }
    const params = {
      ...paramsFilter,
      pageNo: 1,
      pageSize: 10,
    };

    try {
      const response = await dispatch(fetchData(params));
      if (response.payload.data.status_code === 200) {
      } else {
        showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  const handleTableChange = async (
    type,
    { page, sizePerPage, sortField, sortOrder, data }
  ) => {
    if (type === "pagination") {
      const params = {
        ...paramsFilter,
        pageNo: page,
        pageSize: sizePerPage,
      };
      try {
        const response = await dispatch(fetchData(params));
        if (response.payload.data.status_code === 200) {
        } else {
          showErrorDialog(response.payload.data.message);
        }
      } catch (error) {
        showErrorDialog(error.message);
      }
    } else {
      const response = await dispatch(
        fetchData({
          ...paramsFilter,
          sort_order: sortOrder,
          sort_field: sortField,
          pageNo: 1,
          pageSize: sizePerPage,
        })
      );
      let result;
      if (sortOrder === "asc") {
        result = data.sort((a, b) => {
          if (a[sortField] > b[sortField]) {
            return 1;
          } else if (b[sortField] > a[sortField]) {
            return -1;
          }
          return 0;
        });
      } else {
        result = data.sort((a, b) => {
          if (a[sortField] > b[sortField]) {
            return -1;
          } else if (b[sortField] > a[sortField]) {
            return 1;
          }
          return 0;
        });
        console.log(result, "desc");
      }
    }
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      handleSearch();
    }
  };

  const handleChangeSales = createChangeHandler(setSales);
  const handleChangeCustomer = createChangeHandler(setCustomer);
  const handleChangePayment = createChangeHandler(setPayment);
  const handleChangeReport = createChangeHandler(setReport);

  const handleDownload = async () => {
    if (report === "") {
      return showDialog("Please select report type");
    }

    try {
      const response = await dispatch(fetchExport(paramsDownload));
      if (response.payload.status === 200) {
        const blob = new Blob([response.payload.data], {
          type: "application/xlsx",
        });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `${report}.xlsx`;
        link.click();
      } else {
        const response = await dispatch(fetchExportNoBlob(paramsDownload));
        if (response.payload.data.status_code === 200) {
        } else {
          showErrorDialog(response.payload.data.message);
        }
      }
    } catch (error) {
      console.log("catch");
      showErrorDialog(error.message);
    }
  };

  return loading ? (
    <LayoutSplashScreen />
  ) : (
    <Card>
      <CardHeader title="Report">
        <CardHeaderToolbar>
          {/* <Button
            className="btn btn-outline-danger mr-4"
            onClick={() =>
              CallApiExport(paramsFilter, fetchExport, dispatch, report)
            }
          >
            Export
          </Button> */}
        </CardHeaderToolbar>
      </CardHeader>
      <CardBody>
        {/* Filter */}
        <Form className="mb-5">
          <Form.Group as={Row}>
            <Col sm={6}>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>
                    Report Type <b className="color-red">*</b>{" "}
                  </b>
                </Form.Label>
                <Col sm={6}>
                  <Select
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                    options={optionsReport}
                    value={getValueStatus(report, optionsReport)}
                    placeholder="Select ..."
                    onChange={handleChangeReport}
                    // isClearable={true}
                  />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Sales</b>
                </Form.Label>
                <Col sm={6}>
                  <Select
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                    options={optionsSales}
                    value={getValueStatus(sales, optionsSales)}
                    placeholder="Select ..."
                    onChange={handleChangeSales}
                    isClearable={true}
                  />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Journey Date</b>
                </Form.Label>
                <Col sm={6}>
                  <InputDateRange
                    setEndDate={setEndDate}
                    setStartDate={setStartDate}
                    endDate={endDate}
                    startDate={startDate}
                    CallApi={fetchData}
                    paramsFilter={paramsFilter}
                    paramsStart={"start_journey_date"}
                    paramsEnd={"end_journey_date"}
                    hidden={false}
                  />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Branch</b>
                </Form.Label>
                <Col sm={6}>
                  <Select
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                    options={optionsBranch}
                    value={getValueStatus(branch, optionsBranch)}
                    placeholder="Select ..."
                    onChange={handleChangeBranch}
                    isClearable={true}
                  />
                </Col>
              </Form.Group>
            </Col>

            {/* Right Row */}

            <Col sm={6}>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Customer</b>
                </Form.Label>
                <Col sm={6}>
                  <Form.Control
                    type="text"
                    value={customer}
                    onChange={(e) => setCustomer(e.target.value)}
                    onKeyPress={handleKeyPress}
                  />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Payment Type</b>
                </Form.Label>
                <Col sm={6}>
                  <Select
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                    options={optionsPaymentType}
                    value={getValueStatus(payment, optionsPaymentType)}
                    placeholder="Select ..."
                    onChange={handleChangePayment}
                    isClearable={true}
                  />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Payment Date</b>
                </Form.Label>
                <Col sm={6}>
                  <InputDateRange
                    setEndDate={setEndPaymentDate}
                    setStartDate={setStartPaymentDate}
                    endDate={endPaymentDate}
                    startDate={startPaymentDate}
                    CallApi={fetchData}
                    paramsFilter={paramsFilter}
                    paramsStart={"start_payment_date"}
                    paramsEnd={"end_payment_date"}
                    hidden={false}
                  />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Product</b>
                </Form.Label>
                <Col sm={6}>
                  <Form.Control
                    type="text"
                    value={product}
                    onChange={(e) => setProduct(e.target.value)}
                    onKeyPress={handleKeyPress}
                  />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Col sm={6}>
                  <Button
                    className="btn btn-outline-danger mr-4"
                    onClick={handleSearch}
                  >
                    Search
                  </Button>
                  {report && report !== "JourneyDetail" && (
                    <Button
                      className="btn btn-danger mr-4"
                      onClick={handleDownload}
                    >
                      Download
                    </Button>
                  )}
                </Col>
                {/* <Col sm={3}>
                  <Button
                    className="btn btn-warning"
                    onClick={() => history.push("/masterdata/vendor-create")}
                  >
                    Create
                  </Button>
                </Col> */}
              </Form.Group>
            </Col>
          </Form.Group>
        </Form>

        {/* Table */}

        {/* <ReportTable
          data={Array.isArray(data) ? data : []}
          page={pageNo}
          sizePerPage={pageSize}
          totalSize={totalRecord}
          onTableChange={handleTableChange}
          loading={loading}
        /> */}

        {data && data.length > 0 && (
          <ReportTable
            data={Array.isArray(data) ? data : []}
            page={pageNo}
            sizePerPage={pageSize}
            totalSize={totalRecord}
            onTableChange={handleTableChange}
            loading={loading}
            report={report}
            dispatch={dispatch}
            paramsDownload={paramsDownload}
          />
        )}
      </CardBody>
    </Card>
  );
};
